import Vue from 'vue';

const frontendApiUrl = process.env.VUE_APP_FUBON_FRONTEND_API_URL;

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  indexPageData: null,  //- 首頁資料
  memberProfile: null,  //- 會員基本資料
};

// getters
const getters = {};

// actions
const actions = {
  //- 取得使用者資料 及 首頁功能資料
  index({commit}) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/service-pages`)
      .then( res => {
        commit('setIndexPageData', res.data);
      });
  },
  //- 取得會員基本資料
  getMemberProfile({commit}) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/member-info`)
      .then( res => {
        commit('setMemberProfile', res.data);
      });
  },
  getLastestImportantMessage({ commit }) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/latest-important-messages`)
      .then( res => {
        return res;
      });
  }
};

// mutations
const mutations = {
  //- 取得使用者資料 及 首頁功能資料
  setIndexPageData(state, data) {
    Vue.set(state, 'indexPageData', data.data);
  },
  //- 取得會員基本資料
  setMemberProfile(state, data) {
    Vue.set(state, 'memberProfile', data.data);
  },
  //- 清除會員基本資料
  resetMemberProfile(state) {
    Vue.set(state, 'memberProfile', null);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
